import { DatePipe } from '@angular/common';
import { Component, input } from '@angular/core';
import {
  SelectionButtonComponent,
  UnselectionButtonComponent,
  WinCardComponent,
} from '@shared/components/challenges/elements';
import { IconComponent } from '@shared/components/icon/icon.component';
import { CampaignPhase } from '@shared/constants';
import { ElementDirective } from '@shared/directives';
import { FrequencyChallenge } from '@shared/factory';
import { FrequencyChallengeSecondVariantConfig } from '@shared/models';
import {
  SafePipe,
  TransformUrlToBgPipe,
  VariableReplacementPipe,
} from '@shared/pipes';

import { FrequencyBaseClass } from '../frequency.base.class';

@Component({
  selector: 'b2c-variant2',
  styleUrl: './variant2.component.scss',
  templateUrl: './variant2.component.html',
  imports: [
    SafePipe,
    DatePipe,
    IconComponent,
    ElementDirective,
    WinCardComponent,
    TransformUrlToBgPipe,
    VariableReplacementPipe,
    SelectionButtonComponent,
    UnselectionButtonComponent,
  ],
})
export class Variant2Component extends FrequencyBaseClass {
  challenge = input.required<FrequencyChallenge>();
  config = input.required<FrequencyChallengeSecondVariantConfig>();

  withShadow = input<boolean>(true);
  isBisCampaign = input<boolean>(false);
  isEventChallenge = input<boolean>(false);
  phase = input<CampaignPhase>(CampaignPhase.CURRENT);
}
